const useHcDomain = () => {
  const hcDomain = document
    .getElementById('hc-sign-up-funnel-react-app')
    ?.getAttribute('data-hc-domain');

  return hcDomain || null;
};

export default useHcDomain;
